import styled from "styled-components";
import { motion } from "framer-motion";
import { Swiper } from "swiper/react";

export const Section = styled.section`
  align-items: flex-start;
  background-color: rgb(0, 0, 0);
  display: flex;
  flex: 0 0 auto;
  flex-flow: column;
  gap: 0px;
  height: min-content;
  overflow: visible;
  position: relative;
  width: 100%;
  z-index: 2;
  // min-height: 100vh;
`;

export const GodsContainer = styled.div`
  border-top: 4px solid rgb(247, 96, 0);
  align-items: center;
  background-color: rgb(0, 0, 0);
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 60px;
  height: min-content;
  justify-content: flex-start;
  overflow: visible;
  padding: 80px 60px 0;
  position: relative;
  width: 100%;
  z-index: 2;

  @media (max-width: 768px) {
    gap: 30px;
    padding: clamp(30px, 6vw, 60px) 0;
  }
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  height: min-content;
  justify-content: center;
  max-width: 1280px;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;
`;

export const GodsContent = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 16px;
  height: min-content;
  justify-content: flex-start;
  max-width: 840px;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const GodsSubTitle = styled.p`
  flex-shrink: 0;
  transform: none;
  font-size: 20px;
  letter-spacing: -0.01em;
  line-height: 130%;
  color: rgb(247, 96, 0);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const GodsTitle = styled.div`
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  will-change: transform;
  flex: none;
  height: auto;
  position: relative;
  white-space: pre-wrap;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word;
`;

export const GradientText = styled.h2`
  font-family: "Inter Display", sans-serif;
  font-size: 48px;
  letter-spacing: -0.03em;
  line-height: 120%;
  font-weight: 400;
  color: rgb(204, 204, 204);
  background: linear-gradient(
    24deg,
    rgb(255, 255, 247) 0%,
    rgba(255, 255, 247, 0.34) 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const Line = styled(motion.div)`
  align-items: center;
  background: linear-gradient(
    90deg,
    #d6d6d600,
    #d6d6d63d 37.38738738738739%,
    #d6d6d699 51.96896114864865%,
    #b2b2b23d 66.27252252252251%,
    #0000 99.99999999999972%
  );
  display: flex;
  flex: none;
  height: 1px;
  justify-content: center;
  overflow: hidden;
  padding: 0 60px;
  position: relative;
  width: 100%;
  will-change: opacity;
`;

export const WorkContainer = styled.div`
  align-items: center;
  background-color: rgb(0, 0, 0);
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 40px;
  min-height: 900px;
  justify-content: center;
  overflow: hidden;
  padding: 80px 40px;
  position: relative;
  user-select: none;
  width: 100%;
  z-index: 2;

  @media (max-width: 1024px) {
    min-height: 700px;
  }

   @media (max-width: 800px) {
    min-height: 600px;
  }

  @media (max-width: 768px) {
    min-height: 500px;
    padding: clamp(30px, 6vw, 60px) clamp(15px, 4vw, 30px);
    gap: 30px;
  }
`;

export const SlideContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  transition: all 0.5s ease;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
`;

export const GodImage = styled.img`
  width: 273px;
  height: 385px;
  object-fit: contain;
  border-radius: inherit;
  background: transparent;
  transition: all 0.5s ease;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);

  @media (max-width: 1440px) {
    width: calc(180px + (273 - 180) * ((100vw - 768px) / (1440 - 768)));
    height: calc(282px + (385 - 282) * ((100vw - 768px) / (1440 - 768)));
  }

  @media (max-width: 768px) {
    width: 180px;
    height: 282px;
  }
`;

export const StyledSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;
  perspective: 2000px;
  position: relative;

  .swiper-wrapper {
    transform-style: preserve-3d;
    align-items: center;
  }

  .swiper-slide {
    transition: all 0.5s ease;
    transform-style: preserve-3d;
    backface-visibility: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    &:not(.swiper-slide-active) {
      ${SlideContent} {
        opacity: 0.8;
      }
      ${GodImage} {
        filter: brightness(0.7);
        width: 273px;
        height: 385px;

        @media (max-width: 1440px) {
          width: calc(180px + (273 - 180) * ((100vw - 768px) / (1440 - 768)));
          height: calc(282px + (385 - 282) * ((100vw - 768px) / (1440 - 768)));
        }

        @media (max-width: 768px) {
          width: 180px;
          height: 282px;
        }
      }
    }
  }

  .swiper-slide-active {
    transform: translateZ(0) scale(1);
    z-index: 2;

    ${SlideContent} {
      opacity: 1;
    }
    ${GodImage} {
      filter: brightness(1);
      width: 470px;
      height: 575px;

      @media (max-width: 1440px) {
        width: calc(280px + (470 - 280) * ((100vw - 768px) / (1440 - 768)));
        height: calc(400px + (575 - 400) * ((100vw - 768px) / (1440 - 768)));
      }

      @media (max-width: 768px) {
        width: 280px;
        height: 400px;
      }
    }
  }

  .swiper-slide-prev {
    transform: translateX(25%) translateZ(-200px) rotateY(-25deg);
    z-index: 1;
  }

  .swiper-slide-next {
    transform: translateX(-25%) translateZ(-200px) rotateY(25deg);
    z-index: 1;
  }

  .swiper-button-next,
  .swiper-button-prev {
    color: rgba(255, 255, 255, 0.8);
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    backdrop-filter: blur(4px);
    transform: translateY(-50%);
    margin-top: 0;

    &:after {
      font-size: 24px;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.7);
    }

    @media (max-width: 1440px) {
      width: 40px;
      height: 40px;
      &:after {
        font-size: 20px;
      }
    }

    @media (max-width: 768px) {
      width: 35px;
      height: 35px;
      &:after {
        font-size: 18px;
      }
    }
  }

  .swiper-button-prev {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
  }

  .swiper-button-next {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }

  .swiper-pagination {
    display: none;
  }
`;
